import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const getATMData = async (queryid, atmid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "atm",
      pid: "RunQuery4",
      dat: {
        queryid: queryid,
        atmid: atmid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getAllATMData = async () => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "atm",
      pid: "getAllATMData",
      dat: {...sessionData},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBillInventory = async (atmid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "atm",
      pid: "ReadATMCassetteNotesCount",
      dat: {
        atmid: atmid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};